const riot = require('riot');

riot.tag2('module-job-list', '<div class="f fclm s-full rounded-8 elevation-default-low bg-white"> <div class="f fm fbw px32 pt32 pb28"> <div class="w-full" data-is="module-section-header" title="イベント発行/CSVのエクスポート結果"> <yield to="right"><i class="icon-refresh fs24 text-gray_60 cursor-pointer" onclick="{parent.onDebounceRefreshJobs}"></i></yield> </div> </div> <div class="flex-fixed f fm w-full mb24"> <div class="w-full py14 text-center border-bottom ts-hxs cursor-pointer transition bold bw2 {opts.current === tab.id ? &quot;text-navy border-navy&quot;: &quot;text-gray_60 border-gray_10&quot;}" each="{tab in tabs}" onclick="{onChangeTab}">{tab.name}</div> </div> <div class="f fclm w-full" show="{opts.current===&quot;import&quot;}"> <div class="max-height-320 w-full" data-is="module-table" schemas="{importJobsTableSchemas}" items="{opts.importJobs}"></div> <div class="flex-fixed f fr px28"> <div ref="import_pagination" data-is="atom-pagination" pagination="{opts.importPagination}"></div> </div> </div> <div class="f fclm w-full" show="{opts.current===&quot;export&quot;}"> <div class="max-height-320 w-full" data-is="module-table" schemas="{exportJobsTableSchemas}" items="{opts.exportJobs}"></div> <div class="flex-fixed f fr px28"> <div ref="export_pagination" data-is="atom-pagination" pagination="{opts.exportPagination}"></div> </div> </div> </div>', 'module-job-list,[data-is="module-job-list"]{display:block}', '', function(opts) {
    this.tabs = [
      {id: 'import', name: 'イベント発行'},
      {id: 'export', name: 'CSVのエクスポート'},
    ];

    this.importJobsTableSchemas = [
      {
        id: 'created_at',
        label: '開始日時',
        class: 'w160 flex-fixed',
        align: 'left',
        getText: (v) => dayjs(v).format('YYYY-MM-DD HH:mm'),
      },
      {
        id: 'status',
        label: 'ステータス',
        class: 'w128 flex-fixed',
        align: 'center',
        component: 'distribution_event_csv_job_status-badge',
      },
      {
        id: 'failed_reason',
        label: '失敗理由',
        class: 'min-width-176 w0 flex-auto',
        align: 'left',
      },
    ];

    this.exportJobsTableSchemas = [
      {
        id: 'created_at',
        label: '開始日時',
        class: 'w160 flex-fixed',
        align: 'left',
        getText: (v) => dayjs(v).format('YYYY-MM-DD HH:mm'),
      },
      {
        id: 'format_type',
        label: 'フォーマット',
        class: 'w220 flex-fixed',
        align: 'left',
        getText: (v) => app.data.constants.onetime_hash_export_job_format_types.find(t => t.id === v).name
      },
      {
        id: 'status',
        label: 'ステータス',
        class: 'w128 flex-fixed',
        align: 'center',
        component: 'onetime_hash_csv_job_status-badge',
      },
      {
        id: 'failed_reason',
        label: '失敗理由',
        class: 'min-width-176 w0 flex-auto',
        align: 'left',
      },
      {
        id: 'menu',
        component: 'material-icon-button',
        align: 'center',
        class: 'flex-fixed w52',
        text: 'more_vert',
        onclick: (item, e) => {
          this.onOpenJobActionSheet(item, e);
        },
        shouldShow: (item, e) => {
          return item.status === 'complete';
        },
      },
    ];

    const LIMIT = 50;

    this.on('mount', async () => {

      this.companyId = this.opts.distributionRule.company.id;
      this.projectId = this.opts.distributionRule.project.id;
      this.projectRef = app.api.child(`companies/${this.companyId}/projects/${this.projectId}`);

      this.refs.import_pagination.on('paginationchange', async (offset_type) => {
        var indicator = spat.modal.indicator();
        var offset = opts.importPagination[offset_type];

        try {
          this.bubbleTrigger('importPaginationChanged', {
            offset: offset,
          });
        }
        catch (e) {
          console.error(e);
          spat.modal.alert(e.message);
        }
        finally {
          indicator.close();
        }
      });

      this.refs.export_pagination.on('paginationchange', async (offset_type) => {
        var indicator = spat.modal.indicator();
        var offset = opts.exportPagination[offset_type];
        try {
          this.bubbleTrigger('exportPaginationChanged', {
            offset: offset,
          });
        }
        catch (e) {
          console.error(e);
          spat.modal.alert(e.message);
        }
        finally {
          indicator.close();
        }
      });
    });

    this.onChangeTab = (e) => {
      if (opts.current === e.item.tab.id) return;
      this.bubbleTrigger('importExportTabChange', {
        current: e.item.tab.id,
      });
    };

    this.onOpenJobActionSheet = (item, e) => {
      e.preventDefault();
      e.stopPropagation();
      var options = [
        {
          icon: "cloud-download",
          label: "ダウンロード",
          action: () => { popup.close(); this.downloadCSV(item); },
        },
      ];

      var popup = spat.popup.open('popup-action-sheet', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 8,
        align: {x: 'right'},
        position: 'bottom',
        opts: {
          options,
        }
      });
    };

    this.downloadCSV = async (item) => {
      var url = item.url;
      var name = item.path.replace('onetime_hash_csv/', '');
      try {
        let res = await fetch(url);
        if (!res.ok) {
          console.error(res);
          spat.modal.alert('ダウンロードに失敗しました');
          return;
        }
        let blob = await res.blob();
        var url = URL.createObjectURL(blob, { type: 'text/csv' });
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        link.click();
        URL.revokeObjectURL(url);
      }
      catch (e) {
        console.error(e);
        spat.modal.alert('ダウンロードに失敗しました');
      }
    };

    this.onDebounceRefreshJobs = _.debounce(() => {
      this.bubbleTrigger('onImportExportJobRefreshClicked');
    }, 1000, true);
});